export const SET_MAIN_CLIENT = 'SET_MAIN_CLIENT';
export const SET_CO_CLIENT = 'SET_CO_CLIENT';
